import React, { useState } from 'react';
import { X, Plus } from 'lucide-react';
interface NewCampaignModalProps {
  isOpen: boolean;
  onClose: () => void;
  onCreateCampaign: (name: string) => void;
}
export const NewCampaignModal = ({
  isOpen,
  onClose,
  onCreateCampaign
}: NewCampaignModalProps) => {
  const [campaignName, setCampaignName] = useState('');
  if (!isOpen) return null;
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (campaignName.trim()) {
      onCreateCampaign(campaignName.trim());
      setCampaignName('');
    }
  };
  const handleClose = () => {
    setCampaignName('');
    onClose();
  };
  return <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-id="element-529">
      <div className="bg-white rounded-xl max-w-md w-full shadow-2xl" data-id="element-530">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200" data-id="element-531">
          <div className="flex items-center gap-3" data-id="element-532">
            <div className="w-10 h-10 bg-[#6366f1]/10 rounded-lg flex items-center justify-center" data-id="element-533">
              <Plus className="w-5 h-5 text-[#6366f1]" data-id="element-534" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900" data-id="element-535">
              New Campaign
            </h3>
          </div>
          <button onClick={handleClose} className="text-gray-400 hover:text-gray-600 transition-colors" data-id="element-536">
            <X className="w-5 h-5" data-id="element-537" />
          </button>
        </div>

        {/* Content */}
        <form onSubmit={handleSubmit} className="p-6 space-y-6" data-id="element-538">
          <div data-id="element-539">
            <label htmlFor="campaignName" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-540">
              Campaign Name
            </label>
            <input id="campaignName" type="text" value={campaignName} onChange={e => setCampaignName(e.target.value)} placeholder="e.g., Q1 Enterprise Outreach" className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#6366f1] focus:border-transparent outline-none" autoFocus data-id="element-541" />
            <p className="mt-2 text-xs text-gray-500" data-id="element-542">
              Give your campaign a descriptive name to help you identify it
              later
            </p>
          </div>

          {/* Footer */}
          <div className="flex gap-3" data-id="element-543">
            <button type="button" onClick={handleClose} className="flex-1 px-4 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 font-medium transition-colors" data-id="element-544">
              Cancel
            </button>
            <button type="submit" disabled={!campaignName.trim()} className="flex-1 px-4 py-3 bg-[#6366f1] text-white rounded-lg hover:bg-[#5457e5] font-semibold transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2" data-id="element-545">
              <Plus className="w-4 h-4" data-id="element-546" />
              Create Campaign
            </button>
          </div>
        </form>
      </div>
    </div>;
};